import { selectIsQualifiedForCafe } from "../selectors/selectCafeInfo";
import { selectIsQualifiedForMarket } from "../selectors/selectContractInfo";
import { selectIsQualifiedForDoghouse } from "../selectors/selectDoghouseInfo";
import { selectIsQualifiedForThemedEvent } from "../selectors/selectEventInfo";
import { selectIsQualifiedForExternalBarn } from "../selectors/selectExternalBarnInfo";
import { selectIsQualifiedForHarbor } from "../selectors/selectHarborInfo";
import { selectIsQualifiedForLibrary } from "../selectors/selectLibraryInfo";
import { selectIsQualifiedForNursery } from "../selectors/selectNurseryInfo";
import { selectIsQualifiedForPier } from "../selectors/selectPierInfo";
import { selectIsPlayerQualifiedForTournament } from "../selectors/selectTournamentInfo";
import { selectIsQualifiedForWaterTower } from "../selectors/selectWatertowerInfo";
import { IdOutskirtBuildings } from "./IdOutskirtBuildings";
export var mapOutskirtsQualifiers = new Map([
    [IdOutskirtBuildings.Cafe, selectIsQualifiedForCafe],
    [IdOutskirtBuildings.Doghouse, selectIsQualifiedForDoghouse],
    [IdOutskirtBuildings.TournamentTent, selectIsPlayerQualifiedForTournament],
    [IdOutskirtBuildings.Watertower, selectIsQualifiedForWaterTower],
    [IdOutskirtBuildings.Nursery, selectIsQualifiedForNursery],
    [IdOutskirtBuildings.ThemedEvent, selectIsQualifiedForThemedEvent],
    [IdOutskirtBuildings.Market, selectIsQualifiedForMarket],
    [IdOutskirtBuildings.ExternalBarn, selectIsQualifiedForExternalBarn],
    [IdOutskirtBuildings.Library, selectIsQualifiedForLibrary],
    [IdOutskirtBuildings.Pier, selectIsQualifiedForPier],
    [IdOutskirtBuildings.Harbor, selectIsQualifiedForHarbor],
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/mapOutskirtsQualifiers.tsx
// module id = 2153
// module chunks = 3